import React from 'react';
import YouTube from 'react-youtube';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faComment, faDownload } from '@fortawesome/free-solid-svg-icons';

import Auth from 'Components/Layouts/Auth';
import ViewCmsElementRecordModal from 'Components/Partials/Modals/ViewCmsElementRecordModal';
import CmsElement from 'Components/Utilities/CmsElement';
import { Loading } from 'Components/Partials';
import { ModalTrigger } from 'Components/Modal';

import { getRecordValue } from 'Services/CmsHelpers';
import { asset } from 'Services/BaseHelpers';

import OnDemandItem from './OnDemandItem';

export default class ProductShowcase extends CmsElement {
    /**
     * @constructor
     */
    constructor(props) {
        super(props);
        this.topVideoRef = React.createRef();
    }


    /**
     * @var cmsElementIdentifier
     * @type {string}
     */
    cmsElementIdentifier = 'product-showcase';

    /**
     * @var useHeaders
     * @type {boolean}
     */
    useHeaders = true;

    headerHasFeatured = {};

    /**
     * @var useTopVideo
     * @type {boolean}
     */
    useTopVideo = false;

    /**
     * @var state
     */
    state = {
        params: {
            element: 'product-showcase',
            paginate: false,
            search: '',
        },
        content: null,
        working: true,
        topVideo: null,
    };

    header = () => (
        <div className="h-banner bg-banner-product-showcase bg-no-repeat bg-cover bg-right relative">
            <div className="absolute h-full w-full flex">
                <span className="m-auto text-app-green-banner text-4xl font-gilroy">Product Showcase</span>
            </div>
            <img
                alt=""
                src={asset("/images/pages/product-showcase/left.svg")}
                className="max-h-banner hidden md:block h-full px-2 md:px-4 lg:px-6  py-5 lg:mt-0"
            />
        </div>
    );

    /**
     * @method render
     * @return {*}
     */
    render() {
        const { working, records: content } = this.state;
        const headers = [
            'Competitive', 'Fitness', 'Recreation', 'Hardgoods', 'Junior', 'Basics & Sustainability', 'Sell-in Decks'
        ];

        // let headers = [];
        //
        // if (this.useHeaders && content && content.data) {
        //     headers = [...new Set(
        //         content.data.map(item => item.header)
        //     )];
        // }

        const noHeader = content?.data.filter(c => !getRecordValue(c, 'header'));

        return (
            <Auth
                customHeader={this.header()} contentClass="bg-white w-full flex-1 bg-app-gray -mt-10"
                containerWidth="" containerPadding="0">
                {working && <Loading />}

                {!working &&
                    <div className="relative z-10">
                        {(!content.data || content.data.length === 0) && (
                            <p className="text-center text-black">
                                There are no items to show you.
                            </p>
                        )}
                        <div className="max-w-screen-2xl w-full mx-auto mt-20">
                            <div className="w-2/3 mx-auto">
                                <p className="text-center text-black">
                                    Product decks currently show a mix of S224 and previous season 'seasonal imagery'.
                                    All CADs are S2-24 and seasonal imagery will be updated in the coming days and a follow up note once available.
                                </p>
                            </div>
                        </div>
                        {noHeader.length > 0 && (
                            <div className="max-w-screen-2xl w-full mx-auto mt-14">
                                <div className="w-2/3 mx-auto">
                                    <div className={
                                        'video-grid grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-2 gap-4'
                                    }>
                                        {content?.data.filter(c => !c.header).map(this.renderItem)}
                                    </div>
                                </div>
                            </div>
                        )}

                        {content.data && this.useHeaders && headers.filter(c => !!c).map((header, k) => {
                            let items = content.data.filter(o => getRecordValue(o, 'header') === header);
                            const featured = items.filter(i => getRecordValue(i, 'featured'));
                            const hasFeatured = featured.length >= 1;

                            if (hasFeatured) {
                                items = items.filter(i => i.id !== featured[0].id);
                            }

                            this.headerHasFeatured[header] = hasFeatured;

                            return (
                                <div className="mt-6 last:mb-6 pt-6 pb-6 even:bg-app-green-light" key={`header-${k}`}>
                                    <div className="max-w-screen-2xl w-full mx-auto">
                                        <div className="w-2/3 mx-auto">
                                            {hasFeatured && this.renderFeatured(featured[0])}

                                            {!hasFeatured && (<>
                                                <p className="font-bold text-2xl mb-3 text-center md:text-left">
                                                    {header}
                                                </p>

                                                {items.length === 0 && (
                                                    <p className="mb-3 text-center md:text-left text-black">
                                                        There are no videos available.
                                                    </p>
                                                )}
                                            </>)}

                                            {items.length > 0 && (
                                                <div className={
                                                    'video-grid grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-2 ' +
                                                    'gap-4 ' + (hasFeatured ? 'pt-14' : '')
                                                }>
                                                    {items.map(this.renderItem)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                }
            </Auth>
        );
    }

    /**
     * @method renderItem
     * @param {object} item
     * @return {JSX.Element}
     */
    renderItem = (item) => {
        return (
            // <ModalTrigger
            //     key={item.id}
            //     component={ViewCmsElementRecordModal}
            //     disabled={item.download_file}
            //     props={{
            //         item,
            //         handleToggleLike: this.handleToggleLike,
            //         handleView: this.handleView,
            //         handleCommentNumberUpdate: this.handleCommentNumberUpdate,
            //         title: item.title,
            //         body: this.renderItemBody,
            //         content: null,
            //     }}>
                <OnDemandItem
                    item={item}
                    useTopVideo={this.useTopVideo}
                    setTopVideo={() => {}}
                    hasItem={item && getRecordValue(item, 'video_src')}
                    renderItemBar={this.renderItemBar}
                    renderItemBody={this.renderItemBody}
                />
            // </ModalTrigger>
        );
    };

    /**
     * @method renderFeatured
     * @param {object} item
     * @return {JSX.Element}
     */
    renderFeatured = (item) => {
        const header = getRecordValue(item, 'header');
        const title = getRecordValue(item, 'title');
        const thumbnail = getRecordValue(item, 'thumbnail', 'file');

        return (
            <div
                className="min-h-60 video rounded-sm flex flex-col md:flex-row justify-between col-span-3"
                key={item.id}
            >
                <div className="text-left font-gilroy font-bold md:w-1/4">
                    <div className="text-xl">{header}</div>
                    <div className="text-4xl text-app-blue">{title}</div>
                </div>
                <ModalTrigger
                    className="flex-1 mt-3 md:mt-0"
                    component={ViewCmsElementRecordModal}
                    props={{
                        item,
                        handleToggleLike: this.handleToggleLike,
                        handleView: this.handleView,
                        handleCommentNumberUpdate: this.handleCommentNumberUpdate,
                        title: title,
                        body: this.renderItemBody,
                        content: null,
                    }}
                >
                    <div className="h-full w-full relative">
                        {thumbnail && (
                            <img alt="" src={thumbnail} className="h-96 w-full object-contain" />
                        )}
                        {item && item.allow_likes && (
                            <div className="flex absolute bottom-2 right-2">
                                <FontAwesomeIcon
                                    icon={faHeart}
                                    size="1x"
                                    className={`mx-1 cursor-pointer ${item.user_has_liked ? 'text-app-red' : 'text-black'}`}
                                    onClick={() => this.handleToggleLike(item)}
                                />

                                {(item.total_likes !== undefined && item.total_likes > 0) &&
                                    <div className="text-xs text-black">
                                        x {item.total_likes}
                                    </div>
                                }
                            </div>
                        )}
                    </div>
                </ModalTrigger>
            </div>
        );
    };

    /**
     * @method renderItemBar
     * @param {object} item
     * @param {string} color
     * @return {JSX.Element}
     */
    renderItemBar = (item, color = 'bg-white text-black font-gilroy') => {
        const title = item && getRecordValue(item, 'title');
        const download_file = item && getRecordValue(item, 'download_file', 'file');
        const item_speaker = item && getRecordValue(item, 'speaker');

        return (
            <div className={'flex justify-between p-2 min-h-12 h-full ' + color}>
                <div className="text-left flex flex-col">
                    <p>
                        {item ? title : 'Click on a video below to begin ...'}
                    </p>
                    {item_speaker && (
                        <p className="text-sm mt-2">
                            {item_speaker}
                        </p>
                    )}
                </div>

                <div className={'flex items-center select-none'}>
                    {item && download_file && (
                        <a href={download_file} download target="_blank" className="mr-2">
                            <FontAwesomeIcon
                                icon={faDownload}
                                size="1x"
                                className={'mx-1 cursor-pointer'}
                            />
                        </a>
                    )}

                    {item && item.allow_likes && (
                        <div className="flex mr-2">
                            <FontAwesomeIcon
                                icon={faHeart}
                                size="1x"
                                className={`mx-1 cursor-pointer ${item.user_has_liked ? 'text-app-red' : 'text-black'}`}
                                onClick={() => this.handleToggleLike(item)}
                            />

                            {(item.total_likes !== undefined && item.total_likes > 0) &&
                                <div className="text-xs text-black">
                                    x {item.total_likes}
                                </div>
                            }
                        </div>
                    )}

                    {item && item.allow_comments && (
                        <div className="flex">
                            <FontAwesomeIcon
                                icon={faComment}
                                size="1x"
                                className="mx-1"
                            />

                            {item.total_comments !== undefined && item.total_comments > 0 &&
                                <div className="text-xs text-white">
                                    {item.total_comments}
                                </div>
                            }
                        </div>
                    )}
                </div>
            </div>
        );
    }

    /**
     * @method renderItemBody
     * @param {object} item
     * @param {string} item.video_type
     * @param {string} item.video_src
     * @return {JSX.Element}
     */
    renderItemBody = (item) => {
        // Iframe responsive; https://www.w3schools.com/howto/howto_css_responsive_iframes.asp

        const video_type = item && getRecordValue(item, 'video_type');
        const video_src = item && getRecordValue(item, 'video_src');
        const thumbnail = item && getRecordValue(item, 'thumbnail');

        return (
            <div className="h-full w-full">
                {video_type === 'youtube' && (
                    <YouTube
                        videoId={video_src}
                        id="2g811Eo7K8U"
                        className="w-full h-full"
                        containerClassName="w-full h-80"
                        onPlay={() => this.handleView(item)}
                    />
                )}
                {video_type === 'vimeo' && (
                    <div className="relative h-full w-full" style={{ paddingTop: '56.25%' }}>
                        <iframe src={video_src}
                                className="absolute top-0 left-0 right-0 bottom-0 w-full h-full"
                                frameBorder="0"
                                allow="autoplay; fullscreen; picture-in-picture" allowFullScreen>
                        </iframe>
                    </div>
                )}
                {video_type === 'url' && (
                    <video className="w-full h-full" controls>
                        <source src={video_src} />
                    </video>
                )}

                {!video_type && thumbnail && (
                    <img src={thumbnail} className="h-48 w-full object-contain" />
                )}
            </div>
        );
    }
}
